export default __webpack_public_path__ + "static/media/striding-feather-closer.c3521a87.jpg";